import { render } from "./ChevronDoubleRightIcon.vue?vue&type=template&id=7ca2e0d6"
import script from "./ChevronDoubleRightIcon.vue?vue&type=script&lang=js"
export * from "./ChevronDoubleRightIcon.vue?vue&type=script&lang=js"
script.render = render

export default script